import { takeLatest } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getPatientAllergiesSelector } from '../selectors'
import { PatientAllergiesConstants } from '../store/patientAllergies.constants'
import { IAllergyOptions } from '../store/patientAllergies.types'
import { setTransformedPatientAllergiesOptions } from '../../options/store/options.actions'
import { OptionsConstants } from '../../options/store/options.constants'
import { getPatientAllergyOptionsSelector } from '../../options/selectors'
import { sortAlphabeticallyByName } from '../../../utilities/options.util'

export function* setPatientAllergiesListOptions() {
  const patientAllergies = yield select(getPatientAllergiesSelector)
  const patientAllergyOptions = yield select(getPatientAllergyOptionsSelector)

  const { allergies } = patientAllergies
  try {
    if (!patientAllergyOptions?.chunkedPatientAllergyOptions) {
      return
    }

    sortAlphabeticallyByName(patientAllergyOptions.chunkedPatientAllergyOptions)

    const transformedPatientAllergyList = patientAllergyOptions.chunkedPatientAllergyOptions.map(
      (pa: IAllergyOptions) => {
        const item: IAllergyOptions = allergies.find((item: { name: string | undefined }) => item.name === pa.name)
        if (item) {
          pa.selected = item.selected
        } else {
          pa.selected = false
        }
        return pa
      }
    )
    yield put(setTransformedPatientAllergiesOptions([...transformedPatientAllergyList]))
  } catch (e) {
    yield put(throwPcrException(`getPatientAllergiesOptions() error: ${e}`))
  }
}

export function* setPatientAllergiesOptionsSaga() {
  yield takeLatest(
    [
      OptionsConstants.SET_CHUNKED_PATIENT_ALLERGIES,
      PatientAllergiesConstants.SET_PATIENT_ALLERGIES,
      PatientAllergiesConstants.SAVE_ALLERGIES,
    ],
    setPatientAllergiesListOptions
  )
}
